import React from "react";

export default class PrivacyPolicy extends React.Component {
  render() {
    return (
      <div>
        <h1>Privacy Policy of CanaWho&trade;</h1>
        <h2>1. Introduction.</h2>
        <p>
          Welcome to the CanaWho community. This Privacy Policy (&ldquo;Privacy
          Policy&rdquo;) is important as it describes CanaWho&rsquo;s policies
          on the collection, use, and disclosure of information when you access
          or use CanaWho&rsquo;s (a) mobile applications, websites, portals and
          software that link or reference this Privacy Policy, including
          canawho.com, and (b) social media pages and channels (collectively,
          the &ldquo;Websites&rdquo;), including any media, features, services,
          functions, content, and links offered within (collectively, the
          &ldquo;Services&rdquo;).
        </p>
        <p>&nbsp;</p>
        <h2>2. Contacting CanaWho to Report Violations &amp; Questions.</h2>
        <p>
          If you have any questions, concerns, or complaints with regards to
          CanaWho&rsquo;s Privacy Policy, data collection, or if you would like
          to report any security violations to CanaWho, please contact us. The
          contact information is provided below:
        </p>
        <p>CanaWho Inc</p>
        <p>2238 Dundas Street West</p>
        <p>PO BOX 59047</p>
        <p>Toronto, Ontario M6R 3B5</p>
        <p>
          <a href="mailto:support@canawho.com">support@canawho.com</a>
        </p>
        <p>&nbsp;</p>
        <h2>3. User Consent.</h2>
        <p>
          By submitting Personal Data (as defined below) through the Websites or
          Services, you agree to the terms of this Privacy Policy and you
          consent to the collection, use and disclosure of your Personal Data in
          accordance with CanaWho&rsquo;s Privacy Policy.
        </p>
        <p>&nbsp;</p>
        <h2>4. To Parents and Minors.</h2>
        <p>
          The Websites or Services are intended for adult use only and require
          users to be eighteen (18) years of age or older. Individuals under the
          age of eighteen (18) are prohibited from creating a user profile and
          accessing CanaWho&rsquo;s Websites and Services.
        </p>
        <p>
          If you are a parent or minor, and you become aware that you or your
          minor child has provided CanaWho with personal information, please
          contact CanaWho at&nbsp;
          <a href="mailto:support@canawho.com">support@canawho.com</a>&nbsp;to
          have the account and all related personal information deleted
          immediately.
        </p>
        <p>
          If CanaWho becomes aware of a user on our Websites or Services that
          has&nbsp;NOT&nbsp;reached eighteen (18) years of age, we will
          immediately delete this profile and all related personal information
          associated with this profile.
        </p>
        <p>&nbsp;</p>
        <h2>5. Information We Collect.</h2>
        <p>
          &ldquo;Personal Data&rdquo; is data that enables someone to identify
          you and/or contact you, for example, your name, address, email
          address, telephone number, and also any nonpublic information about
          you that is associated with or linked to any of the data already
          mentioned. &ldquo;Anonymous Data&rdquo; is data that is not associated
          with you or linked to your Personal Data. Anonymous Data does not by
          itself enable the identification of individual people. We collect
          Personal Data and Anonymous Data and it is described below.
        </p>
        <ul>
          <li>Information You Provide to Us.</li>
        </ul>
        <p>
          If you create an account on any of the Websites or Services
          (&ldquo;User Account&rdquo;), we may collect your: full name, email
          address, province, date of birth, and any other information you may
          provide with your User Account. Your username and your profile photo
          that you submit through the account registration process may be
          publicly displayed as part of your User Account in our community.
        </p>
        <p>
          If you use the Services on your mobile device through the mobile
          application, we may collect the unique ID number.
        </p>
        <p>
          If you allow your mobile device to send us your location, we may store
          and use that information to provide you with information based on your
          location.
        </p>
        <p>
          Our Websites and Services allow you to store your preferences, for
          example your location, safe search settings, and cannabis preferences.
          We may associate these preferences with your unique ID, browser, or
          mobile device, and you can change these preferences at any point in
          time.
        </p>
        <p>
          If you contact us via email or provide feedback, we will store your
          name and email address and also any other content included in the
          email to reply to you.
        </p>
        <p>
          When you share an experience (Images, comments, messages, text or any
          other content that is not your email address) on the Websites or
          Services, the information in your experience will be stored in our
          servers and other users will have the ability to see your experiences
          and your profile (&ldquo;Profile&rdquo;).The information you provided
          in your profile (username, experiences, profile photo) will be visible
          to other community members.
        </p>
        <p>
          If you exchange messages with other community members through the
          Websites or services, we may store them to process and deliver them ,
          and we may review and disclose them in connection with investigations
          relating to the use and operation of the Websites and Services.
        </p>
        <p>
          When you take part in our surveys, we may collect additional profile
          information.
        </p>
        <p>
          If you take part in a contest, giveaway, or sweepstake on the Websites
          or Services, we may ask you for your email address and/or contact
          number (to contact you if you are a winner or not). We may also ask
          for your first and last name, and your address to verify your
          identity. In certain situations we may need additional information for
          the entry process. The opportunities (contest, giveaway, and
          sweepstakes) are voluntary and are not mandatory. We suggest you read
          the rules for each opportunity that you decide to enter.
        </p>
        <p>
          We may also collect Personal Data throughout different points in the
          Websites or Services that state Personal Data is being collected.
        </p>
        <p>
          <br />
          <br />
        </p>
        <ul>
          <li>Information Collected Via Technology.</li>
        </ul>
        <p>Information Collected by Our Servers</p>
        <p>
          Information is collected by Our Servers to make the Websites or
          Services better for you. Our servers (which may be hosted by a third
          party service provider) collect information from you, including your
          browser type, Internet Protocol (&ldquo;IP&rdquo;) address (a unique
          number that identifies each computer when using the internet&rdquo;),
          browser type, domain name, and/or a date/time stamp for your visit.
        </p>
        <p>Cookies</p>
        <p>
          Cookies are a small file sent by websites to recognize and keep track
          of your preferences as you view the website. We may use both Session
          Cookies (is erased once a user exits the web browser) and Persistent
          Cookies (remain on your computer until the user deletes them) to
          provide a seamless and engaging experience on the Websites or
          Services. This information is collected to enhance the Websites or
          Services making them more useful and more personable for you.
        </p>
        <p>Log Files</p>
        <p>
          A Log File records events that happen in an operating system. We
          gather precise information automatically and it is stored in Log
          Files. This information includes IP addresses, Internet service
          Provider (&ldquo;ISP&rdquo;), browser type, operating system,
          referring/exit pages, date/time stamp, and clickstream data. This
          information is used to analyze trends, track the movement of users on
          the Websites or Services, gather demographic information about our
          user base as a whole, administer the Websites or Services, and better
          adjust our Websites or Services to our users needs. For example, some
          information may be collected and stored, for when you revisit the
          Websites or Services you will be recognized. We do not link Personal
          Data to automatically collected data.
        </p>
        <p>Data Collected by Advertisers</p>
        <p>
          We may also use third parties to serve ads on the Websites or
          Services. Third parties may automatically collect information about
          your visits to this website and other websites, your IP address, your
          ISP, the browser you use to visit our Websites or Services (but they
          do not collect your name, address, e-mail address or telephone
          number). They do this by using the following technologies: Cookies,
          Pixel Tags, or other technologies. Information collected may be used
          for the following and also amongst other things, to deliver targeted
          advertising related to your interests and to further understand the
          usage and visitation of our Websites and Services and the other sites
          tracked by these third parties. This policy does not apply or extend
          to, and CanaWho is not responsible for, Cookies or Pixel Tags found in
          or a part of third party ads, and we encourage you to review the
          privacy policies of advertisers and/or ad services to learn how they
          use Cookies and other technologies. If you would like more information
          about data collected by third parties and you would like to know your
          choices about not having this information used by these companies,
          click here: http://www.aboutads.info/choices or
          http://www.networkadvertising.org.
        </p>
        <p>Mobile Services</p>
        <p>
          If you have downloaded our mobile application, we collect other
          non-personal information from your mobile device. The collected
          information is normally used to help us deliver the most relatable
          information to you. For example, the information collected may be how
          you use the mobile platform, your navigation throughout the mobile
          platform, geographic location while using the mobile platform, and
          what type of device you may use. Additionally if the mobile platform
          were to crash on your mobile device, we would receive information
          about your mobile device model software and device carrier, which
          enables us to identify and resolve any issues which inturn improves
          overall performance and experience on our mobile platform. The
          information is received in a collection and is not traceable to any
          individual and cannot be used to identify an individual user.
        </p>
        <p>Do Not Track Signals</p>
        <p>
          Users are able to opt out of tracking when using the Websites or
          Services, but each user must identify the province in which they are
          using and/or accessing the Websites or Services.&nbsp;
        </p>
        <p>Analytic Services and Interest-Based Advertising</p>
        <p>
          We have implemented our own tracking technologies but other companies
          may have their own cookies or similar tools when you visit the
          Websites or Services. This may include third party analytic services,
          which includes but is not limited to Firebase Analytics
          (&ldquo;Analytics Services&rdquo;), that we receive to help analyze
          how users use the Websites or Services, as well as third parties that
          have content offers. We may receive reports from these parties from
          the use of these tools on an individual or aggregate basis. We use the
          information we get from Analytics Services to only improve the
          Websites or Services for your overall experience. The information
          collected by the Cookies or other technologies about your use on the
          Websites or Services is transmitted to the Analytics Services. The
          Analytics Services use analyzed data to create reports on user
          activity within the Websites or Services. The Analytics Services may
          share information to third parties when required by law, or where such
          third parties process Analytics Information on their behalf. The
          ability to use and share Analytics Information is restricted by each
          Analytics Services&rsquo; Terms of Use and Privacy Policy. By using
          the Websites or Services, you have given consent to the processing of
          data about you by Analytics Services for the reasons set out above.
          For a full list of Analytics Services, please contact us at&nbsp;
          <a href="mailto:info@canawho.com">info@canawho.com</a>.&nbsp;
        </p>
        <p>Information Collected from Third Party Companies</p>
        <p>
          We may receive Personal and/or Anonymous Data about you from our
          Company Members who may submit information about their customers
          (&ldquo;Customer Data&rdquo;). We may add this information to the
          information we have already collected from you via the Websites or
          Services in order to improve your experience on our platform. The way
          CanaWho uses Customer Data is in accordance with the terms found in
          the CanaWho&rsquo;s Terms of Use and this Privacy Policy or as
          required by law. If any Personal Data has been submitted to us by any
          of our Company Members as Customer Data, and you wish to exercise any
          rights you may inquire with us directly. If you request to update or
          remove Customer Data, we will acknowledge the request within 30 days.
        </p>
        <p>Information on Location</p>
        <p>
          If you have enabled location services on your phone, we collect your
          location information to demonstrate the nearest retail locations to
          you. If you do not want your location information collected by us, you
          may disable location services on your phone.
        </p>
        <p>&nbsp;</p>
        <h2>6. Use Of Your Personal Data.</h2>
        <p>
          General Use. The Personal Data you submit to us is used to respond to
          your requests, or assist us in creating a better experience for you
          throughout the Websites or Services.
        </p>
        <ul>
          <li>To create and secure your Member Account with us;</li>
        </ul>
        <ul>
          <li>Recognize you as a member in our platform;</li>
        </ul>
        <ul>
          <li>
            To come up with, individualize, and enhance the Websites or
            Services;
          </li>
        </ul>
        <ul>
          <li>
            Give feedback to Company Members (registered brands) registered on
            the Websites or Services;
          </li>
        </ul>
        <ul>
          <li>
            Communicate with you about the way you use the Services&rsquo;;
          </li>
        </ul>
        <ul>
          <li>
            Create new products and Services&rsquo; to enhance your experience;
          </li>
        </ul>
        <ul>
          <li>Track your usage on the Websites and Services;</li>
        </ul>
        <ul>
          <li>Recommend content;</li>
        </ul>
        <ul>
          <li>
            To backup our systems and be prepared for recovery in case of a
            disaster;
          </li>
        </ul>
        <ul>
          <li>To carry out your requests and provide customer support;</li>
        </ul>
        <ul>
          <li>
            Send surveys, newsletters, offers and promotional materials related
            to the Services and your user preferences and behaviors and for
            other marketing purposes of CanaWho using your contact information;
          </li>
        </ul>
        <ul>
          <li>
            Protect, investigate and potentially take action against possible
            fraudulent, unauthorized, or illegal activities;
          </li>
        </ul>
        <ul>
          <li>
            Respond to claims that Websites or Services content is inauthentic,
            counterfeit, or otherwise violates the rights of third parties;
          </li>
        </ul>
        <ul>
          <li>
            Protect our rights as a platform and the rights of other community
            members on the platform;
          </li>
        </ul>
        <ul>
          <li>
            Enforce our Terms of Use, this Privacy Policy or any other policies
            governing your access to or use of any of the Websites or Services;
          </li>
        </ul>
        <ul>
          <li>
            As otherwise described in this Privacy Policy or in notices we
            provided to you.&nbsp;
          </li>
        </ul>
        <p>Anonymous Data Created</p>
        <p>
          Your Personal Data may be created into Anonymous Data by excluding
          information (ie. name) that no longer makes the data personally
          identifiable to you. We may use this Anonymous Data to analyze usage
          patterns and better understand the behaviour of our members so that we
          may improve our Websites or Services. We reserve the right to use
          Anonymous Data and aggregated and other de-identified information for
          any purpose and disclose Anonymous Data to third parties at our sole
          discretion.
        </p>
        <p>&nbsp;</p>
        <h2>7. Disclosure of Your Personal Data.</h2>
        <p>Third Parties Designated by You</p>
        <p>
          With your consent or at your discretion we may share your personal
          information. When you use the Services, the Personal Data you provide
          will be shared with the third parties that you designate to receive
          such information, including other websites, your friends, relatives
          and business associates. Depending on the type of access you grant to
          such third parties, they may also be permitted to edit the information
          you have provided to us and to designate others to access and edit
          such information.&nbsp;
        </p>
        <p>Users</p>
        <p>
          We will share your personal data with other community members solely
          for the purpose of providing the services on our platform.
        </p>
        <p>Third Party Service Providers&nbsp;</p>
        <p>
          We may use and rely on third party providers to support or offer some
          of the features and options that are available through the Websites,
          Services or Transactable Sites. We may also rely on third party
          providers to complete particular services for CanaWho in connection
          with how you use the Websites or Services. These services include:
          communication and hosting, network security, customer support,
          technical support, tracking and reporting, quality assurance testing,
          processing of payment, CanaWho marketing of the Websites or Services,
          promotion and contest features, Transactable Sites&rsquo;, product
          listings and brand management, and other functions. We may share your
          information with the third party providers in order for them to
          complete your requests and perform their services. The third party
          providers may share information that they have obtained from or about
          you in connection with providing their services or completing your
          requests with CanaWho. The third party providers may also share this
          information with other companies under common control which include:
          their subsidiaries, joint ventures, affiliates, and partners. In these
          cases, be advised that the information you provide is being provided
          to the third party. These third party service providers are
          required&nbsp;NOT&nbsp;to use your Personal Data for reasons other
          than to provide the services requested by CanaWho.
        </p>
        <p>Affiliates</p>
        <p>
          We may share a portion or all of your Personal Data with other
          companies under common control, for example our parent company, joint
          ventures, or other companies (&ldquo;Affiliates&rdquo;). Our
          Affiliates will be required to honor and respect your privacy as
          outlined in this Privacy Policy.
        </p>
        <p>Restructuring the Corporation</p>
        <p>
          We may share a portion or all of your Personal Data throughout the
          process of merging the company, financing, company acquisition or
          dissolution transaction or proceeding involving sale, transfer,
          divestiture, or disclosure of all or a portion of our business or
          assets. If CanaWho were to reach insolvency, bankruptcy, or
          receivership, Personal Data may also be transferred as an asset of the
          business. Ifwe are acquired by another company, in terms of the
          business, company, or assets; the acquiring company will possess the
          Personal Data collected by CanaWho and will assume all rights and
          obligations regarding your Personal Data as outlined in this Privacy
          Policy.
        </p>
        <p>Social Networking Services</p>
        <p>
          You may be able to post content to social networking services (ie.
          Facebook, Twitter, LinkedIn). If you choose to do this, you
          acknowledge and agree that it is your responsibility to review the
          Privacy Policy and Terms of Use of the social networking services and
          understand the use of these platforms is solely your responsibility.
          We are not responsible or liable for: the accuracy or availability of
          such social platforms; the content, products or services, or
          availability of such social networking services; or your use of any
          social platform.
        </p>
        <p>Disclosure of Third Party Companies</p>
        <p>
          We may enter into agreement with companies that provide our Services
          by a co-branded or partnered website or companies that offer their
          products and/or services on our website (&ldquo;Third Party
          Companies&rdquo;). A Third Party Company may desire access to Personal
          Data that we collect from our users. With that being said, we may
          reveal your Personal Data to a Third Party Company. We will not reveal
          your Personal Data to any Third Party Company for the Third Party
          Company&rsquo;s own direct marketing purposes or desirable intent,
          unless you have &ldquo;opted- in&rdquo; by following the instructions
          we have provided to allow the disclosure of Personal Data.&nbsp;
        </p>
        <p>
          If you have opted-in to receive email communications from a Third
          Party Company and later wish to discontinue receipt of these emails,
          please contact the Third Party Company directly to update your
          preferences. The use and disclosure of your Personal Data that we
          collect and disclose to such Third Party Companies is subject to the
          privacy policies of these Third Party Companies. We do not control the
          privacy practices of these Third Party Companies, therefore you should
          read and understand their privacy policies.
        </p>
        <p>Registered Companies on CanaWho</p>
        <p>
          We may share information from or about you (such as your age and
          gender), your devices, and your use of the Websites, Services and/or
          Transactable Sites (such as which businesses you view or share
          experiences) with businesses listed on CanaWho. Keep in mind that
          registered businesses may see your Profile on the platform.&nbsp;
        </p>
        <p>Public Profiles</p>
        <p>
          Certain information you provide to us may be displayed in your
          Profile. As part of the Services, some of the Personal Data you
          provide to us when you register or update your Profile is displayed on
          your Profile (ie. Community Username and Province).Your photos,
          experiences, friends, and other content you post on the Websites or
          Services are also meant for public consumption. We may showcase this
          content on the Websites or Services and further distribute it beyond
          our platform through third party sites and services. Once displayed on
          publicly viewable web pages, that information can be collected and
          used by others. We cannot control who views your experiences or what
          other users may do with the information that you voluntarily share, so
          it is very important that you do not share your Personal Data and
          information in the experiences you share. Once you have shared
          information publicly, even though you will be able to remove it from
          the Websites or Services, you will be unable to edit or delete such
          information collected, cached, and stored elsewhere by others (ie.
          search engines).
        </p>
        <p>Other Disclosures</p>
        <p>
          We may disclose your information if we believe it is required to
          prevent any fraudulent, liable, abusive, or unlawful activities or to
          protect CanaWho, our Websites and Services; or any rights, property,
          or personal safety of CanaWho and others. If CanaWho is to be involved
          in any business deal (ie. merger or acquisition) which involves the
          transfer or sale of a portion or all of CanaWho&rsquo;s business or
          assets, CanaWho may transfer your information as part of or in
          connection with the business transaction. The Acquired or Merger will
          subsequently use your personal information in correspondence with this
          Privacy Policy. In conclusion, in the time of insolvency, bankruptcy,
          or receivership, information may be transferred as a business asset.
        </p>
        <h2>&nbsp;</h2>
        <h2>8. Your Choices Regarding Information.</h2>
        <p>
          You have multiple choices with regards to the use of information on
          our Service:
        </p>
        <p>Email Communications</p>
        <p>
          You can modify and/or cancel the email marketing communications you
          receive from CanaWho by following the instructions within our
          promotional emails. This will not affect any future subscriptions, if
          your opt-out preferences are limited to certain types of emails, then
          you will receive your limited preferences. Other subscriptions will
          remain unaffected. CanaWho would like to note, we reserve the right to
          send you particular communications relating to your User Account or
          use of our Websites or Services, such as service and administrative
          announcements which may be unaffected even if you choose to opt-out
          from receiving our marketing communications.&nbsp;
        </p>
        <p>Cookies</p>
        <p>
          If you choose to no longer want to accept cookies from our service for
          any of the reasons described above, then you can change the settings
          in your browser, to stop accepting cookies or to notify you before
          accepting a cookie from the websites you visit. Look into your
          browsers technical information. If you are not accepting cookies, you
          may not be able to experience all portions of the service and
          functionality provided by our service. If you have any questions
          please let us know at the contact information provided below.&nbsp;
          <a href="mailto:support@canawho.com">support@canawho.com</a>
        </p>
        <p>Changing or Deleting Your Personal Data</p>
        <p>
          The websites or services may allow you to review, correct and update
          personal information that you have provided through the Websites or
          Services. We will contribute strong efforts to fulfill requested
          changes in our active databases as soon as reasonably possible. Please
          consider that it is not always possible to delete all of your
          information from our databases completely and that residual data may
          remain stored on backup media or for other reasons. Even if you edit
          your personal information or you change your preferences on the
          Websites or Services, the information that you remove may remain
          present internally for our administrative purposes. If you delete all
          of your Personal Data completely, then your User Account may become
          deactivated as well. We will honour your requests reasonably. We may
          reserve a copy of your records for legitimate business purposes or as
          required by law.
        </p>
        <p>Applications</p>
        <p>
          You can stop the collection of your information done by the mobile
          application by uninstalling the mobile application. You may use the
          standard uninstall processes that come standard with your mobile
          device or you may uninstall the mobile application using the
          marketplace.&nbsp;
        </p>
        <p>&nbsp;</p>
        <h2>9. Changes to this Privacy Policy.</h2>
        <p>
          This Privacy Policy is subject to change, if we make any changes to
          how we use your Personal Data, we will inform you of the changes that
          have been made. You will be notified via email to the last email
          address you provided to us and or by posting the notice of change on
          the Website or Services. Any changes to our Privacy Policy will be
          effective thirty(30) calendar days after you have been contacted via
          email of the changes or thirty(30) calendar days after posting the
          changes on our Websites or Services. The changes made will be
          effective immediately for new users of our Websites or Services.
          Please note that you are responsible for updating your Personal
          Information in order to provide us with your most up to date email
          address. In the time that the last email address that you provided was
          invalid, or is not capable of delivering to you the changes to this
          Privacy Policy, our email containing the notice will nonetheless
          constitute clear notice of the changes described for this Privacy
          Policy. If you do not permit the changes of the use of your Personal
          Data, you must contact us before the effective date of the changes to
          deactivate your account with CanaWho. Continued use of the Websites of
          Services after the notice of the changes, indicates you have
          acknowledged and agreed to the changes of the terms and conditions of
          such changes.
        </p>
      </div>
    );
  }
}
